'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userInvoices = require('./user-invoices.html');

var _userInvoices2 = _interopRequireDefault(_userInvoices);

var _userInvoices3 = require('./user-invoices.controller');

var _userInvoices4 = _interopRequireDefault(_userInvoices3);

require('./user-invoices.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userInvoicesComponent = {
  restrict: 'E',
  bindings: {
    user: '='
  },
  template: _userInvoices2.default,
  controller: _userInvoices4.default,
  controllerAs: 'vm'
};

exports.default = userInvoicesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-invoices/user-invoices.component.js
 **/